import React from "react";
import { connect } from "react-redux";
import language from "../../../../language";
import bloodCenterQuery from "../../../../utils/queries/bloodCenterQuery";
import bloodCenterSiteQuery from "../../../../utils/queries/bloodCenterSiteQuery";
import { defineRoleCenterSite } from "../../../../utils/handleAccessRoles";
import { Input, Select } from "../../../Input";
import { Button } from "../../../Button";
import toastMessage from "../../../../utils/toastMessage";
import api from "../../../../utils/api";
import Result from "./Result";
import moment from "moment";
import { CSVLink } from "react-csv";

let csvData = [];

class Search extends React.Component {
  csvDownload = React.createRef();

  state = {
    error: {},
    showResultModal: false,
    data: [],
    page: 1,
    limit: 10,
    requestStartDate: moment()
      .subtract(1, "M")
      .startOf("D")
      .format("YYYY-MM-DD"),
    requestEndDate: moment().endOf("D").format("YYYY-MM-DD"),
    csvData: [],
    isExporting: false,
    csvHeaders: [],
  
    center: null,
    centerSite: null,
};

  componentDidMount() {
    this.getCenters();
  }

  getCenters = async (q) => {
    try {
      this.setState({
        isFetchingCenter: true,
      });

      const data = await bloodCenterQuery(this.props.defaultLanguage, {
        type: "dropdown",
        page: 1,
        limit: 50,
        q: q !== "" ? q : undefined,
      });

      let center = null;
      const { centerRole } = await defineRoleCenterSite();
      if (!this.props._id && centerRole) {
        data.forEach((el) => {
          if (centerRole.includes(el._id)) {
            center = el;
          }
        });

        this.setState({ center }, () =>
          this.getCenterSites({ center: center?._id || undefined })
        );
      }

      this.setState({
        centers: data,
        isFetchingCenter: false,
      });

      return data;
    } catch (error) {
      this.setState({ isFetchingCenter: false });

      return [];
    }
  };

  getCenterSites = async (search = {}) => {
    if (!search.center) return [];

    try {
      this.setState({
        isFetchingCenterSite: true,
      });

      const data = await bloodCenterSiteQuery(this.props.defaultLanguage, {
        type: "dropdown",
        page: 1,
        limit: 50,
        ...search,
      });

      const { centerSiteRole } = await defineRoleCenterSite();
      let centerSite = null;

      if (!this.props._id && centerSiteRole) {
        data.forEach((el) => {
          if (centerSiteRole.includes(el._id)) {
            centerSite = el;
          }
        });

        this.setState({ centerSite });
      }

      this.setState({
        centerSites: data,
        isFetchingCenterSite: false,
      });

      return data;
    } catch (error) {
      console.log(error);
      this.setState({ isFetchingCenterSite: false });

      return [];
    }
  };

  onChangeText = async (field, e) => {
    let { error } = this.state;
    let inputValue = e && e?.target ? e?.target?.value : e;

    delete error[field];

    await this.setState({
      [field]: inputValue,
      error,
    });

    if (field === "center") {
      this.getCenterSites({ center: inputValue?.value });
    }
  };

  validateForm = async () => {
    let { error } = this.state;
    const { center } = this.state;

    if (!center) {
      error.center = language[this.props.defaultLanguage].center_required;
    }

    await this.setState({ error });
  };

  returnFilters = () => {
    const {
      center,
      centerSite,
      page,
      limit,
      requestStartDate,
      requestEndDate,
    } = this.state;

    return {
      center: center?.value,
      centerSite: centerSite?.value,
      page,
      limit,
      requestStartDate,
      requestEndDate,
    };
  };

  onSubmit = async () => {
    try {
      await this.validateForm();

      if (Object.keys(this.state.error).length > 0) return;

      this.setState({ isSubmitting: true });

      const options = {
        method: "GET",
        url: `/preDonationAssessment`,
        params: this.returnFilters(),
      };

      const { data = {} } = await api(options);

      const result = data.data;

      const results = this.formatData(result);

      this.setState({
        data: results,
        isSubmitting: false,
        totalPageCount: data.count,
      });

      if (data.length === 0) {
        toastMessage(
          "info",
          language[this.props.defaultLanguage].no_data_found
        );
      }
    } catch (error) {
      console.log("error", error);
      this.setState({ isSubmitting: false });
      toastMessage("error", error);
    }
  };

  formatData = (data) => {
    const formattedData = data.map((el) => {
      el.healthQuestionnaire.forEach((item) => {
        el[item?.questionText] = item?.answer;
        el[item?.answerType] = item?.answer;
      });

      if (el.donor) {
        el["address"] =
          el.donor?.province +
          " " +
          el.donor?.district +
          " " +
          el.donor?.sector +
          " " +
          el.donor?.cell +
          " " +
          el.donor?.village;
      }

      delete el.healthQuestionnaire;

      return el;
    });

    return formattedData;
  };

  handlePagination(page, _tab, limit) {
    this.setState(
      {
        page,
        ...(limit != null && { limit }),
      },
      () => {
        this.onSubmit();
      }
    );
  }

  handleClose() {
    this.setState({
      isExporting: false,
    });
  }

  handleExport = async (headers) => {
    try {
      this.setState({ isExporting: true });
      const { limit, page } = this.state;

      const options = {
        method: "GET",
        url: `/preDonationAssessment`,
        params: {
          ...this.returnFilters(),
          page,
          limit,
        },
      };

      const { data } = await api(options);

      const results = this.formatData(data.data);

      this.setState({
        isExporting: false,
      });

      if (results.length === 0) {
        toastMessage(
          "info",
          language[this.props.defaultLanguage].no_data_found
        );

        return;
      }

      const csvHeaders = headers.map((item) => ({
        label: item.title,
        key: item.key,
      }));

      csvData = results.slice(0);

      this.setState(
        {
          csvHeaders,
          downloadReady: true,
        },
        () => {
          // Trigger download after state is updated
          setTimeout(() => {
            this.csvDownload.current?.link.click();
            this.setState({ isExporting: false, downloadReady: false });
          }, 0);
        }
      );
    } catch (error) {
      console.log("error", error);
      this.setState({ isExporting: false });
      toastMessage("error", error);
    }
  };

  render() {
    return (
      <>
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-3">
                  <Select
                    loadOptions={(e) => this.getCenters(e)}
                    placeholder={language[this.props.defaultLanguage].select}
                    label={language[this.props.defaultLanguage].center}
                    required
                    value={this.state.center}
                    onChange={(e) => this.onChangeText("center", e)}
                    error={this.state.error.center}
                    isLoading={this.state.isFetchingCenter}
                  />
                </div>
                <div className="col-md-3">
                  <Select
                    key={this.state?.center?.value || "no-center"}
                    isDisabled={!this.state?.center?.value}
                    loadOptions={(e) =>
                      this.getCenterSites({
                        q: e,
                        center: this.state?.center?.value,
                      })
                    }
                    placeholder={language[this.props.defaultLanguage].select}
                    label={language[this.props.defaultLanguage].center_site}
                    value={this.state.centerSite}
                    onChange={(e) => this.onChangeText("centerSite", e)}
                    error={this.state.error.centerSite}
                    isLoading={this.state.isFetchingCenterSite}
                  />
                </div>
                <div className="col-md-3">
                  <Input
                    label={language[this.props.defaultLanguage].start_date}
                    value={this.state.requestStartDate}
                    onChange={(e) => this.onChangeText("requestStartDate", e)}
                    error={this.state.error.requestStartDate}
                    type="date"
                  />
                </div>
                <div className="col-md-3">
                  <Input
                    label={language[this.props.defaultLanguage].end_date}
                    value={this.state.requestEndDate}
                    onChange={(e) => this.onChangeText("requestEndDate", e)}
                    error={this.state.error.requestEndDate}
                    type="date"
                  />
                </div>
                <div className="col-md-12">
                  <Button
                    text={language[this.props.defaultLanguage].search}
                    onPress={this.onSubmit.bind(this)}
                    isSubmitting={this.state.isSubmitting}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {this.state.data.length > 0 && (
          <div className="card">
            <div className="card-body">
              <div className="row">
                <Result
                  data={this.state.data}
                  title={
                    language[this.props.defaultLanguage].export +
                    " " +
                    this.state.startDate +
                    " - " +
                    this.state.endDate
                  }
                  page={this.state.page}
                  limit={this.state.limit}
                  totalPageCount={this.state.totalPageCount}
                  totalRecords={this.state.totalRecords}
                  handlePagination={this.handlePagination.bind(this)}
                  csvData={this.state.csvData}
                  handleExport={(e) => this.handleExport(e)}
                  isExporting={this.state.isExporting}
                />
              </div>
            </div>
          </div>
        )}
        <CSVLink
          data={csvData}
          headers={this.state.csvHeaders}
          filename={`Donors ${this.state.requestStartDate}-${this.state.requestEndDate}.csv`}
          className="hidden"
          ref={this.csvDownload}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { filters } = state.Filters;
  return {
    defaultLanguage,
    filters,
  };
};

export default connect(mapStateToProps)(Search);
